module.exports = __webpack_public_path__ + "static/img/icon90.f3e01270.png";